export function data() {
  return {
    tabs: [
      { name: 'list', label: 'Board Meetings' },
      { name: 'locations', label: 'Meeting Locations' }
    ],
    transitionName: 'slide-down'
  }
}
